import {backendUrl} from "@shared/constants/urls/appUrls";

export const apiEndpoints = {
    calendar: `${backendUrl}/api/calendar/`,
    calendarEvent: `${backendUrl}/api/calendar/event/?id=`,
    calendarMonthly: `${backendUrl}/api/calendar/monthly/`
};

export const requestOptions = {
    get: {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    },
    post: (body) => ({
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
    })
};
